/**
 * Whether the Designs editor offers a playlist.
 *
 * The same shape as lib/network.ts: the feature name the server spells, and
 * absent where it was not bought rather than present and refusing. A playlist is
 * the signage module's (internal/licence/features.go); a picture is not.
 */
export const SIGNAGE_MODULE = 'signage'

export function offersSignage(modules: readonly string[] | undefined): boolean {
  return (modules ?? []).includes(SIGNAGE_MODULE)
}

/** Signage on kiosks; off, campaigns name the hall board only and a kiosk draws no media. Twin of layout.KioskSignage. */
export const KIOSK_SIGNAGE = false

/** Whether a screen of this kind plays a media area. */
export function mediaOffered(kind: string, kioskSignage: boolean = KIOSK_SIGNAGE): boolean {
  return kind !== 'kiosk' || kioskSignage
}
